import { useImportResultQuery } from "generated/graphql";

interface UseGetImportResultOptions {
  skip?: boolean;
}

export const useGetImportResult = (taskId: string, { skip = true }: UseGetImportResultOptions = {}) =>
  useImportResultQuery({
    //   /*
    //    * Chris @ 13 Sep 2021:
    //    *
    //    * We should be handling this by using `stopPolling()` in the consuming component, but it doesn't work!
    //    * It just keeps polling.
    //    *
    //    * Instead I've forced `pollInterval` to 0 here if `skip = true`
    //    *
    //    * Source: https://github.com/apollographql/react-apollo/issues/3129
    //    */
    pollInterval: skip ? 0 : 5000,
    skip,
    variables: {
      task: taskId,
    },
  });
